import { createSignal } from 'simple-react-signal';
var updatedAtSignal = createSignal(Date.now());
var navbarContextValueSignal = createSignal({
    contentOverride: null,
    update: function update(content) {
        navbarContextValueSignal.update({
            contentOverride: content,
            update: navbarContextValueSignal.ref.current.update
        });
        updatedAtSignal.update(Date.now());
    }
});
export default function useNavbarContext() {
    return navbarContextValueSignal.use();
}

//# sourceMappingURL=useNavbarContext.js.map